import { useRequest } from 'ahooks';
import { useState } from 'react';
import {
  caseAppointmentSlotService,
  caseAppointmentSubmitService,
  createTicketByAiccService,
  createTicketService,
  getCaseTypeListService,
  getEmergTypeListService,
  getServiceTypeListService,
  getSysparam,
  getTicketListService,
} from './services';

export default function TicketMgrModal() {
  const [selectedServiceNumber, setSelectedServiceNumber] = useState<any>({}); // 选中的service number

  const { runAsync: queryTicketList } = useRequest(getTicketListService, {
    manual: true,
  });

  const { data: emergTypeList, run: queryEmergTypeList } = useRequest(
    getEmergTypeListService,
    {
      manual: true,
    },
  );

  const { data: serviceTypeList, run: queryServiceTypeList, mutate: mutateServiceTypeList } = useRequest(
    getServiceTypeListService,
    {
      manual: true,
    },
  );

  const { data: caseTypeList, run: queryCaseTypeList } = useRequest(
    getCaseTypeListService,
    { manual: true },
  );

  const { loading: ticketLoding, runAsync: createTicket } = useRequest(
    createTicketService,
    {
      manual: true,
    },
  );

  const { loading: ticketByAiccLoading, runAsync: createTicketByAicc } =
    useRequest(createTicketByAiccService, { manual: true });

  const { data: appointmentCase, run: getAppointmentCase } = useRequest(
    () =>
      getSysparam({ mask: 'BCARE_TIME_OFFSER_VALUE_CHANGE_APPOINTMENT_CASE' }),
    {
      manual: true,
    },
  );

  const {
    data: caseAppointmentSlotList,
    run: caseAppointmentSlot,
    loading: caseAppointmentSlotLoading,
  } = useRequest(caseAppointmentSlotService, {
    manual: true,
  });

  const {
    runAsync: caseAppointmentSubmit,
    loading: caseAppointmentSubmitLoading,
  } = useRequest(caseAppointmentSubmitService, {
    manual: true,
  });

  return {
    emergTypeList,
    caseTypeList,
    serviceTypeList,
    ticketLoding,
    appointmentCase,
    createTicket,
    ticketByAiccLoading,
    createTicketByAicc,
    queryTicketList,
    queryEmergTypeList,
    queryServiceTypeList,
    queryCaseTypeList,
    getAppointmentCase,
    caseAppointmentSlot,
    caseAppointmentSlotList,
    caseAppointmentSlotLoading,
    caseAppointmentSubmit,
    caseAppointmentSubmitLoading,
    selectedServiceNumber,
    setSelectedServiceNumber,
    mutateServiceTypeList
  };
}
